import { render } from "./ClientForm.vue?vue&type=template&id=1f12325e&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=ts"
export * from "./ClientForm.vue?vue&type=script&lang=ts"

import "./ClientForm.vue?vue&type=style&index=0&id=1f12325e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f12325e"

export default script